import { addQueryParamsToPath } from 'lib/url/searchUrlUtils'

export function addTripIdParam(link: string, tripId: string, canEdit: boolean) {
  if (!canEdit) {
    return link
  }
  return addQueryParamsToPath(link, { tripId })
}
